import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { ClientLicenseEntity } from './client-license.entity';
import { UserEntity } from './user.entity';

/**
 * Entity for tracking users who are watching a license.
 * Used by the notification system to send activity updates.
 */
@Index('license_user__fk_user__id_fk', ['fkUserId'], {})
@Index('license_user_pk', ['fkLicenseId', 'fkUserId'], { unique: true })
@Entity('license_user')
export class LicenseUserEntity
	extends BaseEntity
	implements EntityWatcherModel
{
	@Column('int', { name: '_fk_license__id', unsigned: true })
	public fkLicenseId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => ClientLicenseEntity, (license) => license.licenseUsers, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_license__id', referencedColumnName: 'id' }])
	public fkLicense!: ClientLicenseEntity;
}
